import { createContext } from 'react';
import { Issue } from '../../constants';
export const MagazineContext = createContext<MagazineContext>({
    issues: [],
});

interface MagazineContext {
    issues: Array<Issue>;
    isPreview?: boolean;
}
